"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _text = require("../../constants/text");

var _CanvasFactory = _interopRequireDefault(require("../../preview/CanvasFactory"));

var _TextProperties = _interopRequireDefault(require("../../preview/text/TextProperties"));

var _TextRenderProperties = _interopRequireDefault(require("../../preview/text/TextRenderProperties"));

var _convertEmToPixel = _interopRequireDefault(require("../../utils/font/convertEmToPixel"));

var _getCanvasFontProperty = _interopRequireDefault(require("../../utils/font/getCanvasFontProperty"));

var _getTextAlign = _interopRequireDefault(require("../../utils/text/getTextAlign"));

var _isEmptyString = _interopRequireDefault(require("../../utils/object/isEmptyString"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var _isRTLText = _interopRequireDefault(require("../../utils/string/isRTLText"));

var _setCanvasTextDirection = _interopRequireDefault(require("./setCanvasTextDirection"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SPACE = ' ';
var HYPHEN = '-';
var EMPTY = '';
var HAIR_SPACE = "\u200A";

var CanvasTextMeasurer = /*#__PURE__*/function () {
  function CanvasTextMeasurer(canvasFactory) {
    (0, _classCallCheck2["default"])(this, CanvasTextMeasurer);
    (0, _defineProperty2["default"])(this, "_canvasFactory", null);

    if (!_CanvasFactory["default"].isCanvasFactory(canvasFactory)) {
      throw new Error('CanvasTextMeasurer needs a CanvasFactory');
    }

    this._canvasFactory = canvasFactory;

    var measureCanvas = this._canvasFactory.getCanvas(); // Set an arbitrary width/height on measure canvas just to be sure it has some dimensions.
    // This will also clear out any content that might be drawn within it.


    measureCanvas.width = 100;
    measureCanvas.height = 100;
    this._textMeasureContext = measureCanvas.getContext('2d');
  }

  (0, _createClass2["default"])(CanvasTextMeasurer, [{
    key: "_measureText",
    value: function _measureText(textProperties) {
      var _this = this;

      if (!_TextProperties["default"].isTextProeprties(textProperties)) {
        throw new Error("textProperties must be of type TextProperties ".concat(textProperties));
      }

      var fillColor = textProperties.fillColor,
          fontName = textProperties.fontName,
          fontSize = textProperties.fontSize,
          horizontalAlignment = textProperties.horizontalAlignment,
          letterSpacing = textProperties.letterSpacing,
          lineSpacing = textProperties.lineSpacing,
          textBoxPadding = textProperties.padding,
          textEffect = textProperties.textEffect,
          textString = textProperties.textString,
          wrapProperties = textProperties.wrapProperties;
      var wrapWidth = wrapProperties.get('width');
      var isRTL = (0, _isRTLText["default"])(textString);

      this._textMeasureContext.clearRect(0, 0, 100, 100);

      this._textMeasureContext.font = (0, _getCanvasFontProperty["default"])(fontName, fontSize);
      this._textMeasureContext.fillStyle = "".concat(fillColor); // This will set the alignment property on the canvas text, which then tells canvas
      // to render the text relative to the origin point in different directions
      // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/textAlign

      var textAlignment = (0, _getTextAlign["default"])(horizontalAlignment, isRTL);
      this._textMeasureContext.textAlign = textAlignment; // Set the direction on the canvas, or context.

      var textDirection = isRTL ? _text.TEXT_DIRECTION.RTL : _text.TEXT_DIRECTION.LTR;
      (0, _setCanvasTextDirection["default"])(this._textMeasureContext, textDirection);
      var lineBoxPadding = textEffect.get('boxPadding') || 0;
      var leftRightPadding = (0, _convertEmToPixel["default"])(_text.DEFAULT_HORIZONTAL_PADDING_FOR_TEXT, fontSize);
      var padding = textBoxPadding + leftRightPadding + lineBoxPadding;
      var letterSpacer = HAIR_SPACE.repeat(Math.max(0, letterSpacing));
      var initialX = padding;

      if (horizontalAlignment === _text.TEXT_ALIGNMENT.RIGHT) {
        initialX = wrapWidth - padding;
      } else if (horizontalAlignment === _text.TEXT_ALIGNMENT.CENTER) {
        initialX = wrapWidth / 2;
      }

      if (isRTL) {
        if (horizontalAlignment === _text.TEXT_ALIGNMENT.LEFT) {
          initialX = wrapWidth - padding;
        } else if (horizontalAlignment === _text.TEXT_ALIGNMENT.RIGHT) {
          initialX = padding;
        }
      }

      var lineHeight = (0, _convertEmToPixel["default"])(lineSpacing, fontSize);
      var firstLineHeight = (0, _convertEmToPixel["default"])(_text.DEFAULT_TOP_PADDING_FOR_TEXT, fontSize);
      var paddedWrapWidth = wrapWidth - padding * 2;
      var maxWidth = 0;
      var outputLines = [];
      var x = initialX;
      var y = firstLineHeight; // Canvas by default draws up from the baseline, so in our configuration Y is the baseline.

      var textLines = textString.replace(/\n+$/g, EMPTY).split('\n');
      textLines.forEach(function (textLine, index) {
        // Create a list of objects that contain the next words and the spacer character
        // that should follow that word within the same line
        // The objects contain a list of words and the corresponding spacers for them.
        var wordGroups = textLine.split(SPACE).map(function (word) {
          // if the word is empty (a trailing space, usually) then return a group with SPACE value
          // to preserve multiple spaces
          if ((0, _isEmptyString["default"])(word)) {
            return {
              words: [SPACE],
              spacers: [SPACE]
            };
          }

          var hyphenSplit = word.split(HYPHEN);
          var currentWordHasHyphens = hyphenSplit.length > 2 || hyphenSplit.length > 1 && !(0, _isEmptyString["default"])(hyphenSplit[hyphenSplit.length - 1]); // If the word is not hyphenated, return single word value.

          if (!currentWordHasHyphens) {
            return {
              words: [word],
              spacers: [SPACE]
            };
          }

          var hyphenatedWords = [];
          var hyphenSpacers = [];
          hyphenSplit.forEach(function (hyphenPart, index) {
            var isLast = index === hyphenSplit.length - 1; // Add hyphens back to every word except the last

            var wordPart = isLast ? hyphenPart : "".concat(hyphenPart).concat(HYPHEN); // Set the spaces

            var spacer = isLast ? SPACE : EMPTY;
            hyphenatedWords.push(wordPart);
            hyphenSpacers.push(spacer);
          });
          return {
            words: hyphenatedWords,
            spacers: hyphenSpacers
          };
        });
        var outputLine = EMPTY;
        var currentSpacer = EMPTY;
        var textLineWidth = 0;
        var textLineFontHeight = 0;
        var textLineActualHeight = 0;
        var textLineActualWidth = 0;
        var currentWordGroupIndex = 0;
        var lineWordCount = 0;
        var textLineActualBoundingBoxAscent = 0;
        var textLineFontBoundingBoxAscent = 0;
        var textLineFontBoundingBoxDescent = 0;
        var textLineActualBoundingBoxLeft = 0;

        while (currentWordGroupIndex < wordGroups.length) {
          var _wordGroups$currentWo = wordGroups[currentWordGroupIndex],
              currentWords = _wordGroups$currentWo.words,
              spacers = _wordGroups$currentWo.spacers;
          var currentWordIndex = 0;

          while (currentWordIndex < currentWords.length) {
            var word = currentWords[currentWordIndex]; // Set up the character that separates the word, sometimes empty.

            var spacer = lineWordCount > 0 ? currentSpacer : EMPTY;
            var textToAppend = void 0;

            if (letterSpacing > 0) {
              // If there is letter spacing, add in spacing characters
              // Final output here looks like <added spaces><space><added spaces><word split with spaces>
              var firstFiller = spacer === EMPTY ? EMPTY : letterSpacer;
              var innerFiller = lineWordCount === 0 ? EMPTY : letterSpacer;
              var wordWithFiller = word.split('').join(letterSpacer);
              textToAppend = "".concat(firstFiller).concat(spacer).concat(innerFiller).concat(wordWithFiller);
            } else {
              textToAppend = "".concat(spacer).concat(word);
            }

            var testLine = "".concat(outputLine).concat(textToAppend);
            lineWordCount++;

            var metrics = _this._textMeasureContext.measureText(testLine);

            var actualBoundingBoxAscent = metrics.actualBoundingBoxAscent,
                actualBoundingBoxDescent = metrics.actualBoundingBoxDescent,
                actualBoundingBoxLeft = metrics.actualBoundingBoxLeft,
                actualBoundingBoxRight = metrics.actualBoundingBoxRight,
                emHeightAscent = metrics.emHeightAscent,
                emHeightDescent = metrics.emHeightDescent,
                fontBoundingBoxAscent = metrics.fontBoundingBoxAscent,
                fontBoundingBoxDescent = metrics.fontBoundingBoxDescent,
                testWidth = metrics.width;
            var targetText = "".concat(testLine); // we have a single word that is longer than the line width, so find a sub-word that fits
            // the line length, process that as a separate word, and add the remainder to the remaining
            // words to process

            if (testWidth > paddedWrapWidth && lineWordCount === 1 && targetText.length > 1) {
              // variables initialised with at least a single character because this algo can be used on fonts
              // large enough that a single letter will exceed the expected width - if we don't setup with a
              // single character, then we get stuck in an infinite loop
              var oldLine = targetText[0];
              var newLine = targetText[0];

              var width = _this._textMeasureContext.measureText(newLine).width;

              var chars = 1;

              while (width < paddedWrapWidth && chars < targetText.length) {
                oldLine = newLine;
                newLine = targetText.substr(0, chars);
                width = _this._textMeasureContext.measureText(newLine).width;
                chars++;
              } // we want the number of characters from the actual word that can fit on the line as the word
              // will be split in 2, with each running through this algorithm again. If we include the white
              // space in the word split, each word will keep growing, causing an infinite loop because whitespace
              // is introduced to each word at the start of this loop


              var actualCharsTracked = oldLine.split('').filter(function (x) {
                return x !== EMPTY && x !== letterSpacer && x !== HAIR_SPACE;
              }).length;
              var wordOne = word.substr(0, actualCharsTracked);
              var wordTwo = word.substr(actualCharsTracked);

              if (wordOne.length > 0) {
                currentWords.splice(currentWordIndex, 1, wordOne);
              } else {
                currentWordIndex++;
              }

              if (wordTwo.length > 0) {
                currentWords.splice(currentWordIndex + 1, 0, wordTwo);
              } // if we're creating two words from one, we need an extra spacer entry, as you need one spacer per word


              if (wordOne.length > 0 && wordTwo.length > 0) {
                spacers.splice(currentWordIndex, 0, spacers[currentWordIndex]);
              }

              lineWordCount--;
            } else if (testWidth > paddedWrapWidth && lineWordCount > 1) {
              // If the current width is wider that the desired width, add current line to the output lines
              outputLines.push({
                actualBoundingBoxAscent: textLineActualBoundingBoxAscent,
                actualBoundingBoxLeft: textLineActualBoundingBoxLeft,
                actualHeight: textLineActualHeight,
                actualWidth: textLineActualWidth,
                fontBoundingBoxAscent: textLineFontBoundingBoxAscent,
                fontBoundingBoxDescent: textLineFontBoundingBoxDescent,
                fontHeight: textLineFontHeight,
                line: outputLine,
                lineHeight: lineHeight,
                width: textLineWidth,
                x: x,
                y: y
              }); // Reset current output line and word count

              outputLine = EMPTY;
              lineWordCount = 0;
              y += lineHeight;
            } else {
              // Otherwise just continue to the next word, saving the current line values
              // Font ascent/descent is not supported in all browsers, this is a best guess approximation
              // https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics
              // The following values were found to best match the font metrics from canvas in Chrome
              // via trial and error and a little math.
              var fontPadding = (0, _convertEmToPixel["default"])(_text.DEFAULT_HORIZONTAL_PADDING_FOR_TEXT, fontSize / 2);
              var defaultFontAscent = fontSize - fontPadding;
              var defaultFontDescent = fontPadding * 3;
              var fontAscent = (0, _isNumber["default"])(emHeightAscent) ? emHeightAscent : fontBoundingBoxAscent;
              var fontDescent = (0, _isNumber["default"])(emHeightDescent) ? emHeightDescent : fontBoundingBoxDescent;
              outputLine = testLine;
              textLineWidth = testWidth;
              textLineFontBoundingBoxAscent = (0, _isNumber["default"])(fontAscent) ? fontAscent : defaultFontAscent;
              textLineFontBoundingBoxDescent = (0, _isNumber["default"])(fontDescent) ? fontDescent : defaultFontDescent;
              textLineFontHeight = textLineFontBoundingBoxAscent + textLineFontBoundingBoxDescent;
              textLineActualHeight = actualBoundingBoxAscent + actualBoundingBoxDescent; // https://github.com/Automattic/node-canvas/issues/1703

              textLineActualWidth = actualBoundingBoxRight - actualBoundingBoxLeft;
              textLineActualBoundingBoxLeft = actualBoundingBoxLeft;
              textLineActualBoundingBoxAscent = actualBoundingBoxAscent;
              maxWidth = Math.max(maxWidth, textLineWidth);
              currentSpacer = spacers[currentWordIndex]; // Update the word index

              currentWordIndex++;
            }
          } // Update the word-group index


          currentWordGroupIndex++;
        } // Push the remaining line on to the output


        outputLines.push({
          actualBoundingBoxAscent: textLineActualBoundingBoxAscent,
          actualBoundingBoxLeft: textLineActualBoundingBoxLeft,
          actualHeight: textLineActualHeight,
          actualWidth: textLineActualWidth,
          fontBoundingBoxAscent: textLineFontBoundingBoxAscent,
          fontBoundingBoxDescent: textLineFontBoundingBoxDescent,
          fontHeight: textLineFontHeight,
          line: outputLine.trim(),
          lineHeight: lineHeight,
          width: textLineWidth,
          x: x,
          y: y
        });

        if (index < textLines.length - 1) {
          y += lineHeight;
        }
      }); // TODO format or type for this? Typescript?
      // TODO a class for this? TextLineData?

      return {
        height: y + (0, _convertEmToPixel["default"])(0.2, fontSize),
        // Stands as a proxy for next draw point, ergo height
        width: maxWidth,
        lines: outputLines
      };
    }
  }, {
    key: "_findFontSize",
    value: function _findFontSize(textProperties, desiredHeight, desiredWidth) {
      // TODO See if we can calculate based on measured size, then binary search?
      var finalTextProperties = new _TextProperties["default"](textProperties);

      var _this$_measureText = this._measureText(textProperties),
          height = _this$_measureText.height,
          lines = _this$_measureText.lines,
          width = _this$_measureText.width;

      var originalFontSize = textProperties.fontSize,
          fillProperties = textProperties.fillProperties;
      var fillMode = fillProperties.get('mode');

      if (fillMode === _text.TEXT_FILL.GROW_TO_FIT && height >= desiredHeight && width <= desiredWidth || fillMode === _text.TEXT_FILL.SHRINK_TO_FIT && height <= desiredHeight && width <= desiredWidth || fillMode === _text.TEXT_FILL.AUTO && height === desiredHeight && width <= desiredWidth) {
        return {
          height: height,
          lines: lines,
          textProperties: finalTextProperties,
          width: width
        };
      }

      var upper = _text.FONT_SIZE_MAX_IN_PIXELS;
      var lower = _text.FONT_SIZE_MIN_IN_PIXELS;
      var current = originalFontSize;

      if (fillMode === _text.TEXT_FILL.GROW_TO_FIT) {
        lower = current;
      }

      if (fillMode === _text.TEXT_FILL.SHRINK_TO_FIT) {
        upper = current;
      } // Binary search through font sizes to find one that fits.
      // TODO check that this works in all cases


      while (upper - lower > 1) {
        if (height === desiredHeight) break;

        if (height < desiredHeight) {
          lower = current;
          current = Math.floor(current + (upper - current) / 2);
        } else {
          upper = current;
          current = Math.floor(current - (current - lower) / 2);
        }

        finalTextProperties.fontSize = current;

        var _this$_measureText2 = this._measureText(finalTextProperties);

        height = _this$_measureText2.height;
        lines = _this$_measureText2.lines;
        width = _this$_measureText2.width;
      }

      var desiredWidthWithPadding = desiredWidth - 2 * (0, _convertEmToPixel["default"])(_text.DEFAULT_HORIZONTAL_PADDING_FOR_TEXT, current); // if text is too wide, shrink it further.

      if (width > desiredWidthWithPadding) {
        upper = current;
        lower = _text.FONT_SIZE_MIN_IN_PIXELS;

        if (fillMode === _text.TEXT_FILL.GROW_TO_FIT) {
          lower = originalFontSize;
        }

        if (fillMode === _text.TEXT_FILL.SHRINK_TO_FIT) {
          upper = originalFontSize;
        } // TODO write a util for this since it is the same as above, mostly


        while (upper - lower > 1) {
          desiredWidthWithPadding = desiredWidth - 2 * (0, _convertEmToPixel["default"])(_text.DEFAULT_HORIZONTAL_PADDING_FOR_TEXT, current);
          if (width === desiredWidthWithPadding) break;

          if (width < desiredWidthWithPadding) {
            lower = current;
            current = Math.floor(current + (upper - current) / 2);
          } else {
            upper = current;
            current = Math.floor(current - (current - lower) / 2);
          }

          finalTextProperties.fontSize = current;

          var _this$_measureText3 = this._measureText(finalTextProperties);

          height = _this$_measureText3.height;
          lines = _this$_measureText3.lines;
          width = _this$_measureText3.width;
        }
      }

      return {
        height: height,
        lines: lines,
        textProperties: finalTextProperties,
        width: width
      };
    }
  }, {
    key: "getTextRenderProperties",
    value: function getTextRenderProperties(inTextProperties) {
      if (!_TextProperties["default"].isTextProeprties(inTextProperties)) {
        throw new Error("textProperties must be of type TextProperties ".concat(inTextProperties));
      }

      var fillProperties = inTextProperties.fillProperties,
          overflowY = inTextProperties.overflowY,
          textBoxPadding = inTextProperties.padding,
          textEffect = inTextProperties.textEffect,
          textString = inTextProperties.textString,
          wrapProperties = inTextProperties.wrapProperties;
      var lineBoxPadding = textEffect.get('boxPadding') || 0;
      var padding = textBoxPadding + lineBoxPadding;

      if ((0, _isEmptyString["default"])(textString)) {
        return new _TextRenderProperties["default"](inTextProperties, [], 0, 0);
      }

      var wrapWidth = wrapProperties.get('width');
      var wrapHeight = wrapProperties.get('height');
      var fillMode = fillProperties.get('mode');
      var fillHeight = wrapHeight - padding * 2;
      var fillWidth = wrapWidth - padding * 2; // Determine font sizes.

      var textWidth;
      var textHeight;
      var textLines = [];
      var finalTextProperties = new _TextRenderProperties["default"](inTextProperties); // Font size is absolute - nothing else to do!

      if ((0, _isNil["default"])(fillMode) || fillMode === _text.TEXT_FILL.ABSOLUTE) {
        var _this$_measureText4 = this._measureText(inTextProperties),
            height = _this$_measureText4.height,
            lines = _this$_measureText4.lines,
            width = _this$_measureText4.width;

        textWidth = width;
        textHeight = height;
        textLines = lines;
      } else {
        // Find the font size base on fill properties
        var _this$_findFontSize = this._findFontSize(inTextProperties, fillHeight, fillWidth),
            foundHeight = _this$_findFontSize.height,
            foundLines = _this$_findFontSize.lines,
            foundProperties = _this$_findFontSize.textProperties,
            foundWidth = _this$_findFontSize.width;

        textWidth = foundWidth;
        textHeight = foundHeight;
        textLines = foundLines;
        finalTextProperties = foundProperties;
      } // Check if lines are overflowing, remove some if they are.
      // Also ellipses


      if (!(0, _isNil["default"])(overflowY) && overflowY !== _text.OVERFLOW_Y.VISIBLE) {
        var originalLineCount = textLines.length;

        if (overflowY === _text.OVERFLOW_Y.HIDDEN || overflowY === _text.OVERFLOW_Y.ELLIPSIS) {
          textLines = textLines.filter(function (_ref, lineIndex) {
            var y = _ref.y;
            return lineIndex === 0 || y <= wrapHeight;
          });
        } // If we've filtered out some lines, lets fix for ellipsis


        if (overflowY === _text.OVERFLOW_Y.ELLIPSIS) {
          var lastTextLine = textLines[textLines.length - 1];
          var line = lastTextLine.line,
              _width = lastTextLine.width,
              y = lastTextLine.y;

          if (_width > fillWidth || originalLineCount > textLines.length) {
            var charRemoveCount = 1;
            var ellipsisLine = "".concat(line).concat(_text.UNICODES.ELLIPSIS);
            var lastLineProperties = new _TextRenderProperties["default"](finalTextProperties);
            lastLineProperties.textString = ellipsisLine;

            var _this$_measureText5 = this._measureText(lastLineProperties),
                lastLinesWithEllipsis = _this$_measureText5.lines;

            while (ellipsisLine.length > _text.UNICODES.ELLIPSIS.length && lastLinesWithEllipsis[0].width > fillWidth) {
              ellipsisLine = "".concat(line.substr(0, line.length - charRemoveCount)).concat(_text.UNICODES.ELLIPSIS);
              lastLineProperties.textString = ellipsisLine;

              var _this$_measureText6 = this._measureText(lastLineProperties),
                  measuredLines = _this$_measureText6.lines;

              lastLinesWithEllipsis = measuredLines;
              charRemoveCount++;
            }

            textLines[textLines.length - 1] = _objectSpread(_objectSpread({}, lastLinesWithEllipsis[0]), {}, {
              y: y
            });
          }
        } // Adjust text height


        textHeight = Math.max.apply(Math, (0, _toConsumableArray2["default"])(textLines.map(function (_ref2) {
          var y = _ref2.y;
          return y;
        })));
      } // Update the rendered font size with the found font size


      finalTextProperties.renderedFontSize = finalTextProperties.fontSize;
      return new _TextRenderProperties["default"](finalTextProperties, textLines, textWidth, textHeight);
    }
  }], [{
    key: "isCanvasTextMeasurer",
    value: function isCanvasTextMeasurer(inObject) {
      return inObject instanceof CanvasTextMeasurer;
    }
  }]);
  return CanvasTextMeasurer;
}();

exports["default"] = CanvasTextMeasurer;